// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__OFyqy","menu":"style_menu__GUN3X"};